import inView from "in-view"

const init = () => {
	inView.offset(150);
	inView('[data-scroll-animate]')
		.on('enter', handleOnEnter);
}

const handleOnEnter = (el) => {
	el.setAttribute('data-scroll-animate', 'visible')
}

export default init